import React, { FC } from 'react'
import { Button } from 'components'
import { useTranslation } from 'react-i18next'

type EnrollmentPackageChoiceProps = {
    onAddPackages: () => void
    onEnrollWithoutPackages: () => void
}

export const EnrollmentPackageChoice: FC<EnrollmentPackageChoiceProps> = ({
    onAddPackages,
    onEnrollWithoutPackages
}) => {
    const { t } = useTranslation()

    return (
        <div className="enrollment-package-choice">
            <div className="enrollment-package-choice__actions">
                <Button
                    style="primary"
                    className="enrollment-package-choice__btn enrollment-package-choice__btn--skip"
                    data-testid="enrollment-without-packages-btn"
                    onClick={onEnrollWithoutPackages}
                >
                    {t('enrollment.enrollNoPackages')}
                </Button>
                <Button
                    style="primary"
                    className="enrollment-package-choice__btn enrollment-package-choice__btn--add"
                    data-testid="enrollment-add-packages-btn"
                    onClick={onAddPackages}
                >
                    {t('enrollment.addPackages')}
                </Button>
            </div>
        </div>
    )
}
